import { Switch } from '@toolbox/components';
import { useField } from '@toolbox/form';

import type { SwitchProps, SwitchVariant } from '@toolbox/components';
import type { FieldPath, FieldValues, UseFieldProps } from '@toolbox/form';
import type { RequiredBy } from '@toolbox/utils';

export type SwitchFieldProps<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
> = UseFieldProps<FD, Name> &
  RequiredBy<Omit<SwitchProps, 'value'>, 'name'> & { errorMessage: string };

export function SwitchField<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
>({
  required,
  rules,
  keepErrorSpace = true,
  errorMessage,
  ...props
}: SwitchFieldProps<FD, Name> & {
  variant?: SwitchVariant;
}): JSX.Element {
  const {
    field: { ref, ...field },
    fieldState,
  } = useField({
    name: props.name,
    rules: {
      required,
      ...rules,
    },
  });

  return (
    <Switch
      error={fieldState.invalid && errorMessage}
      {...props}
      {...field}
      keepErrorSpace={keepErrorSpace}
    />
  );
}
